<template>
  <div class="carrier-reconcliation">
    <div class="search">
      <el-select
        class="white selectDate"
        v-model="search.select"
        placeholder="请选择"
        @change="changeDateType"
      >
        <el-option
          v-for="item in selectDateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="white w200"
        v-if="search.select === 1"
        v-model="search.date"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-date-picker
        class="white w200"
        v-if="search.select === 2"
        v-model="search.month"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-select
        v-model="search.expressType"
        filterable
        clearable
        class="gray"
        placeholder="请选择承运商"
      >
        <el-option
          v-for="item in logisticsList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button
        class="btn-blue"
        @click="exportBillForm"
      >导出</el-button>
      <el-button
        class="btn-white"
        @click="openDownload"
      >下载</el-button>
    </div>

    <!-- 导出提示 -->
    <el-dialog class="tips-dialog" title="提示" top="20vh" :visible.sync="tipsDialog" width="420px">
      <div>
        <i class="el-icon-warning"></i>
        <span class="tips">导出任务生成成功，共{{exportAllBillNums}}笔，请稍后前往[下载]！</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-blue" @click="closeDialog">确定</el-button>
      </div>
    </el-dialog>

    <!-- 下载 -->
    <el-dialog class="down-dialog" title="下载" top="15vh" :visible.sync="downLoadDialog" width="920px">
      <div class="search-dialog">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-select
          v-model="orderType"
          filterable
          clearable
          class="gray order-type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in orderTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button
          class="btn-blue"
          @click="searchList"
        >搜索</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" style="width: 100%;" height="252px">
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :show-overflow-tooltip="item.showToolTip"
            :min-width="item.width"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                class="btn-text"
                type="text"
                @click="download(scope.row)"
              >下载</el-button>
              <el-button
                class="btn-text"
                type="text"
                @click="del(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDownLoadDialog">关闭</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import Logistics from "models/logistics";
import CarrierReconcliation from "models/carrier-reconcliation.js";
const logistics = new Logistics();
import { formaTimeToMinute } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      search: {
        select: 1,
        date: "",
        month: "",
        expressType: ''
      },
      logisticsList: [],
      selectDateList: [
        { label: "日账单", value: 1 },
        { label: "月账单", value: 2 },
      ],
      tipsDialog: false,
      exportAllBillNums: 0,
      downLoadDialog: false,
      daterange: '',
      orderType: '',
      orderTypeList: [
        {id:1, name: '承运商账单'}
      ],
      orderTypeObj: {
        1: '承运商账单'
      },
      statusObj: {
        1: '正在生成',
        2: '已生成',
        3: '生成失败 '
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '申请时间', prop: 'createTime', width: '140', showToolTip: false},
        {label: '操作员', prop: 'username', width: '', showToolTip: false},
        {label: '类型', prop: 'typeVal', width: '', showToolTip: true},
        {label: '笔数', prop: 'dataNum', width: '', showToolTip: false},
        {label: '状态', prop: 'statusVal', width: '', showToolTip: false},
        {label: '最后下载时间', prop: 'lastDownloadTime', width: '140', showToolTip: false},
        {label: '下载次数', prop: 'downloadTimes', width: '', showToolTip: false},
      ]
    }
  },

  created() {
    this.getLogisticsList()
  },

  methods: {
    /* 获取快递类型 */
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
        }
      });
    },
    
    changeDateType(v) {
      this.search.select = v
    },

    closeDialog() {
      this.tipsDialog = false
    },

    /* 导出日账单 */
    exportBillForm() {
      if (this.search.select == 1) this.exportDaysBillForm()
      if (this.search.select == 2) this.exportMonthBill()
    },

    /* 导出日账单 */
    exportDaysBillForm() {
      if (!this.search.date) return this.$message.error('请选择日期');
      if (!this.search.expressType) return this.$message.error('请选择承运商');
      let data = {
        expressType: this.search.expressType,
        date: this.search.date
      }
      CarrierReconcliation.postExport(data).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },

    /* 导出月账单 */
    exportMonthBill() {
      if (!this.search.month) return this.$message.error('请选择月份');
      if (!this.search.expressType) return this.$message.error('请选择承运商');
      let data = {
        expressType: this.search.expressType,
        date: this.search.month
      }
      CarrierReconcliation.postExportMonthBill(data).then(res => {
        if (res.success) {
          this.exportAllBillNums = res.result
          this.tipsDialog = true
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    },

    openDownload() {
      this.downLoadDialog = true
      this.initTableList()
    },
    
    closeDownLoadDialog() {
      this.downLoadDialog = false
    },

    searchList() {
      this.currentPage = 1
      this.initTableList();
    },

    initTableList() {
      let beginTime = this.daterange ? this.daterange[0] : ''
      let endTime = this.daterange ? this.daterange[1] : ''
      let type = this.orderType
      let currentPage = this.currentPage
      let data = {
        beginTime,
        endTime,
        type,
        currentPage
      }
      CarrierReconcliation.getBillList(data).then(res => {
        if (res.success) {
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.type = value.type;
            obj.url = value.url;
            obj.typeVal = this.orderTypeObj[value.type];
            obj.username = value.username;
            obj.createTime = value.createTime ? formaTimeToMinute(value.createTime): '/';
            obj.lastDownloadTime = value.lastDownloadTime ? formaTimeToMinute(value.lastDownloadTime): '/';
            obj.dataNum = value.dataNum;
            obj.downloadTimes = value.downloadTimes;
            obj.status = value.status;
            obj.statusVal = this.statusObj[value.status];
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          console.log(123);
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },

    /* 翻页 */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initTableList();
    },

    download(row) {
      let data = {
        id: row.id
      };
      CarrierReconcliation.getModDownloadTimes(data).then(res => {
        if (res.success) {
          this.initTableList();
          this.$message.success("下载成功");
          window.open(row.url)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      });
    },

    del(id) {
      this.$confirm("删除后不可恢复，是否继续？?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          CarrierReconcliation.getDelBill(id).then(res => {
            if (res.success) {
              this.initTableList();
              this.$message.success("删除成功");
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          });
        })
        .catch(() => {});
    }
  }
}
</script>

<style lang='scss'>
.carrier-reconcliation {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .search {
    padding: 16px;
    background: #fff;
    display: flex;
    border-radius: 4px;
    margin-bottom: 16px;
    .el-button {
      margin-left: 16px;
    }
    .w200 {
      width: 200px;
      margin-right: 16px;
    }
    .selectDate {
      width: 85px;
      .el-input__inner {
        border-right: none;
        border-radius: 4px 0px 0px 4px;
      }
    }
    .el-date-editor {
      .el-select.white .el-input__inner,
      .el-input__inner {
        border-radius: 0px 4px 4px 0px;
      }
    }
  }
  .el-icon-warning {
    color: #2E68EA;
    margin-right: 6px;
    font-size: 16px;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
  }
  .tips-dialog {
    .el-dialog__body {
      height: 72px;
      display: flex;
      align-items: center;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      padding-left: 20px;
      padding-bottom: 0px;
      box-sizing: border-box;
    }
  }
  .dialog-footer {
    padding-top: 10px;
    display: flex;
    justify-content: center;
  }
  .down-dialog {
    .search-dialog {
      margin-bottom: 16px;
      .order-type {
        margin: 0px 20px;
      }
    }
    .el-dialog__body {
      padding-top: 16px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
